export default __webpack_public_path__ + "static/media/668.70a55469.png";